import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import {
  closeFormModal,
  openViewModal,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.reducer";
import { useEffect, useState } from "react";
import {
  updateFraseSeleccionAplicacionPlantelThunk,
  getFrasesSeleccionAplicacionPlantelThunk,
  getFraseSeleccionAplicacionPlantelByIdThunk,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.thunks";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const FraseSeleccionAplicacionFormModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { formModalOpen, selectedFrase, formLoading, formError, page, search } =
    useSelector((state) => state.frasesSeleccionAplicacionPlantel);

  const [formData, setFormData] = useState({ frase: "" });

  useEffect(() => {
    if (selectedFrase) {
      setFormData({ frase: selectedFrase.frase || "" });
    }
  }, [selectedFrase, formModalOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(
      updateFraseSeleccionAplicacionPlantelThunk({
        id: selectedFrase.id,
        payload: formData,
      }),
    );
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(
        getFrasesSeleccionAplicacionPlantelThunk({ plantelId, page, search }),
      );
      toast.success("Frase actualizada exitosamente");
      await dispatch(
        getFraseSeleccionAplicacionPlantelByIdThunk(selectedFrase.id),
      );
      dispatch(openViewModal());
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title="Editar frase"
      size="lg"
    >
      {formLoading ? (
        <Loader center type="dots" text="Actualizando frase..." />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}
          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              value={formData.frase}
              onChange={(e) => setFormData({ frase: e.target.value })}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default FraseSeleccionAplicacionFormModalPlantel;
